<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Días fuera de planta</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="daysOutSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="daysOutListHeaders"
          :items="daysOutListBody"
          class="elevation-3"
          no-data-text="No hay datos"
          :search="daysOutSearch"
          dense
        >
          <template v-slot:[`item.shipping`]="{item}">
            {{ formatDate(item.shipping )}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      daysOutSearch: null,
      url_excel: '',
      isLoading: false,
      daysOutListHeaders: [],
      daysOutListBody: [],
    }),
    mounted() {
      this.loadDaysOutReport();
    },
    methods:{
      async loadDaysOutReport(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}bins/report/daysout`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.daysOutListHeaders = response.data.data.headers;
          this.daysOutListBody = response.data.data.body;
          this.url_excel = this.storage_url + response.data.data.url_excel;
          this.ocultarLoading();
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      
    }
  }
</script>